// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"1d57c153","498":"2de3fdc0","703":"90ad0ee4"}[chunkId] + ".chunk.js";
};